import Lang from "@vendors-bk/messages";

export class PointProduct
{
    constructor(content, productStandard, eventListener, setting = {}, option = {}) {
        this.content = content;
        this.productStandard = productStandard;
        this.eventListener = eventListener;

        this.pointUnit = setting.pointUnit || Lang.get('frontend.cart.title.exchange.unit');
        this.priceAreaClass = option.priceAreaClass || '.js_price_area';
        this.desktopStockSelectClass = option.desktopStockSelectClass || '.js_select_change';
        this.desktopStockBindClass = option.desktopStockBindClass || '.js_select_bind';
        this.mobileStockClass = option.mobileStockClass || '.js_qty_value';

        this.priceDisplay = null;
        this.stockDisplay = null;
    }

    setPriceDisplay(priceDisplay) {
        this.priceDisplay = priceDisplay;
    }

    setStockDisplay(stockDisplay) {
        this.stockDisplay = stockDisplay;
    }

    bindEvents() {
        this.productStandard.bindEvents();
        this.bindStandardChangeListenerEvent();
    }

    bindStandardChangeListenerEvent() {
        this.eventListener.addEventListener('standardChange', (event) => {

            this.refreshProduct();
        });
    }

    refreshProduct() {
        this.refreshProductPrice();
        this.refreshProductQuantity();
    }

    refreshProductPrice() {
        if (this.priceDisplay !== null) {
            this.priceDisplay.build(this);
        }
    }

    refreshProductQuantity(defaultQuantity = 0) {
        if (this.stockDisplay !== null) {
            this.stockDisplay.build(this, defaultQuantity);
        }
    }
}
